export default {
  "content": "_content_iot8o_1",
  "--hover": "_--hover_iot8o_1",
  "--hover-disabled": "_--hover-disabled_iot8o_1",
  "inner": "_inner_iot8o_1",
  "--width-trigger": "_--width-trigger_iot8o_1",
  "--position-top": "_--position-top_iot8o_1",
  "--position-top-end": "_--position-top-end_iot8o_1",
  "--position-top-start": "_--position-top-start_iot8o_1",
  "--position-bottom": "_--position-bottom_iot8o_1",
  "--position-bottom-end": "_--position-bottom-end_iot8o_1",
  "--position-bottom-start": "_--position-bottom-start_iot8o_1",
  "--position-start": "_--position-start_iot8o_1",
  "--position-start-bottom": "_--position-start-bottom_iot8o_1",
  "--position-start-top": "_--position-start-top_iot8o_1",
  "--position-end": "_--position-end_iot8o_1",
  "--position-end-bottom": "_--position-end-bottom_iot8o_1",
  "--position-end-top": "_--position-end-top_iot8o_1",
  "--visible": "_--visible_iot8o_1",
  "--animated": "_--animated_iot8o_1"
};import "ni:sha-256;cGZFPqhdO1cSjPywe9xlmrKT6Umt1jdQ8CwuhY-IfGY";